import { render } from "./show.vue.js?vue&type=template&id=c9866994!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./show.vue?vue&type=template&id=c9866994"
import script from "./show.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./show.vue?vue&type=script&lang=js"
export * from "./show.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./show.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__